module.exports = "/_next/static/images/b6963629aac20dafb63c727808f1c0bc-kpmg.png.webp";